/**
 * @generated SignedSource<<c0a735c7f942b254029f0013326af227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuPromotions_Product$data = {
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly promotions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string;
              readonly highlight: boolean | null;
            };
          }>;
        } | null;
      };
    }>;
  };
  readonly " $fragmentType": "ProductSkuPromotions_Product";
};
export type ProductSkuPromotions_Product$key = {
  readonly " $data"?: ProductSkuPromotions_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuPromotions_Product">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuPromotions_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "addresses",
                      "variableName": "addresses"
                    }
                  ],
                  "concreteType": "PromotionConnection",
                  "kind": "LinkedField",
                  "name": "promotions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PromotionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Promotion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "highlight",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "b127fbca106f7cf5d091d1f011eb692a";

export default node;
